import { MutationTree } from 'vuex';
import * as s_Interface from '@/interface/store/profile';
import { Profile } from '@/interface/store/profile';
import { initialState } from '@/store/modules/profile/index';

export const mutations: MutationTree<Profile> = {
  SET_PROFILE(
    state,
    {
      id,
      fullName,
      email,
      phoneNumber,
      organization,
      position,
      settings,
      emailSettings,
      subscribedToNewsletters,
    }
  ) {
    state.userId = id;
    state.user.fullName = fullName;
    state.user.email = email;
    state.user.phoneNumber = phoneNumber;
    state.user.organization = organization;
    state.user.position = position;
    state.settings = settings;
    state.emailSettings = emailSettings;
    state.subscribedToNewsletters = subscribedToNewsletters;
  },
  SET_AVATAR(state, payload: s_Interface.Avatar) {
    state.avatar = payload;
  },
  RESET_ALL(state) {
    const initialInventoryState = initialState();
    Object.keys(initialInventoryState).forEach((key: any) => {
      (state as any)[key] = (initialInventoryState as any)[key];
    });
  },
  GET_CREDIT_CARDS(state, payload) {
    state.creditCardList = payload.data;
  },
  GET_CREDIT_CARD_ITEM(state, payload) {
    state.creditCardItem = payload;
  },
};
